import { Fields } from '@measured/puck';
import MarginComponent from '../../components/customComponents/MarginComponent';

export type MarginSubProps = {
  top: string;
  bottom: string;
  left: string;
  right: string;
};
export type MarginType = {
  desktop: MarginSubProps;
  tablet: MarginSubProps;
  mobile: MarginSubProps;
  doubleXL?: MarginSubProps;
  tripleXL?: MarginSubProps;
};

export type MarginProps = {
  margin: MarginType;
};
export const marginProps = {
  margin: {
    desktop: {
      top: '0',
      bottom: '0',
      right: '0',
      left: '0',
    },
    tablet: {
      top: '0',
      bottom: '0',
      right: '0',
      left: '0',
    },
    mobile: {
      top: '0',
      bottom: '0',
      right: '0',
      left: '0',
    },
  },
};
export const marginFields: Fields<MarginProps> = {
  margin: {
    type: 'custom',
    label: 'Margin',
    render: ({ value, onChange }) => {
      return (
        <MarginComponent value={value} onChange={onChange} title="Margin" />
      );
    },
  },
};
